import api from './ApiService';

export default {
    sendNote(formData) {
        return api.post('/geraNotas', formData);
    }
}
